// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'global-policy-types',
    standalone: false,
    template: `
        <mon-chart-bar
                [height]="235"
                [labels]="chartLabels"
                [data]="chartData"
                [options]="chartOptions"
                [override]="chartOverrides"
                [colors]="barColors">
        </mon-chart-bar>
    `,
})
export class GlobalPolicyTypesComponent implements OnInit {
    @Input() policies: any;

    chartLabels: any;
    chartData: any;
    chartSeries: any;
    chartOptions: any;
    barColors: any;
    chartOverrides: any;

    constructor (private translateService: TranslateService) {}

    ngOnInit () {
        this.activate();
    }

    private activate () {
        this.chartLabels = [
            this.translateService.getString('Unwanted'),
            this.translateService.getString('Required'),
            this.translateService.getString('Matches'),
        ];
        this.chartData = [
            [
                this.policies.filter(function (policy: any) {
                    return policy.mode === 'violation' && policy.matches_count > 0;
                }).length,
                this.policies.filter(function (policy: any) {
                    return policy.mode === 'required' && policy.matches_count > 0;
                }).length,
                this.policies.filter(function (policy: any) {
                    return policy.mode === 'search' && policy.matches_count > 0;
                }).length,
            ],
        ];
        this.chartSeries = [''];
        const max = this.chartData[0].reduce(function (a: any, b: any) {
            return Math.max(a, b);
        }, 0);
        this.chartOptions = {
            scales: {
                yAxes: [
                    {
                        id: 'y-axis-0',
                        ticks: {
                            min: 0,
                            max: max * 1.5,
                        },
                        display: false,
                        gridLines: {
                            display: false,
                        },
                    },
                ],
                xAxes: [
                    {
                        barPercentage: 1,
                        categoryPercentage: 0.5,
                        gridLines: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            fontColor: '#a6a6a6',
                            fontSize: 11,
                        },
                    },
                ],
            },
            drawLabelOnChart: true,
        };

        this.barColors = ['#a8d6f3', '#a8d6f3', '#a8d6f3'];

        this.chartOverrides = [
            {
                borderWidth: 0,
                backgroundColor: 'rgba(54, 162, 235, 0.5)',
            },
        ];
    }
}
